import { Box, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import SkeletonList from "../../../pages/SpareParts/HomePage/SkeletonList/SkeletonList";
import { WarrantyItemForMissing, WarrantyReason } from "../../../types";
import {
    DialogContainer,
    Label2,
    StyledInputBox,
    Value,
} from "./MissingPartsWrongMaterial.style";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { ShipToAddress } from "../OrderOffer/ShiptToAddress";
import { InvoicesAddress } from "../OrderOffer/InvoicesAddress";
import PartialShipment from "../OrderOffer/PartialShipment";
import OrderOfferNote from "../OrderOffer/OrderOfferNote";
import WarrantyBasketItemsHeader from "../WarrantyBasketItemsHeader";
import WarrantyBasketItems from "../WarrantyBasketItems";
import { OfferOrderReference } from "../OrderOffer/OfferOrderReference";
import DeliveryDate from "../OrderOffer/DeliveryDate";
import ConfirmButton from "../../AppButtons/ConfirmButton";
import { SalesCondition } from "../OrderOffer/SaleCondition";
import { SalesConditionsDTO } from "../../../../explorer/types/OrderOffer/SalesConditions";
import { brand } from "../../../@mock/data/system";
import ServiceProvider from "../../../configuration/ServiceProvider";
import useBrands from "../../../../explorer/hooks/useBrands";
import { SellConditionsContainer } from "../OrderOffer/OrderOfferNotification.style";
import CircleButton from "../../AppButtons/CircleButton";
import { AppIconsDocumentChecked } from "../../AppIcons";

type TMissingPartsWrongMaterialSummary = {
    items: WarrantyItemForMissing[];
    loading: boolean;
    formFields: {
        deliveryAddress: string;
        invoiceAddress: string;
        partialShipment: boolean;
        note: string;
        deliveryDate: string;
        ponReference: string;
        noteItems: {};
        hasAgreement: boolean;
        cgvAgreement:boolean,
    };
    createChangeValueHandler: (
        key:
            | "note"
            | "ponReference"
            | "deliveryAddress"
            | "partialShipment"
            | "deliveryDate"
            | "invoiceAddress"
            | "noteItems"
            | "hasAgreement"
            | "cgvAgreement"
            
    ) => (e: any, value: any) => void;
    createChangeHandler: (
        key:
            | "note"
            | "ponReference"
            | "deliveryAddress"
            | "partialShipment"
            | "deliveryDate"
            | "invoiceAddress"
            | "noteItems"
            | "hasAgreement"
            | "cgvAgreement"
    ) => (e: any, value: any) => void;
};

const MissingPartsWrongMaterialSummary: FC<
    TMissingPartsWrongMaterialSummary
> = (props) => {
    const {
        items,
        loading,
        formFields,
        createChangeValueHandler,
        createChangeHandler,
    } = props;
    const { t } = useTranslation();
    const brand = useBrands().currentBrandUrl;

    const [openSalesCondition, setOpenSalesCondition] = useState(false);
    const [salesConditions, setSalesConditions] =
        useState<SalesConditionsDTO | null>(null);

    const getSalesCondition = () => {
       setOpenSalesCondition(!openSalesCondition);
       if (!openSalesCondition) {
         ServiceProvider.OrderOffer.salesConditions(brand)
           .then((result) => {
             setSalesConditions(result);
           })
           .catch((e) => console.error(e));
       }
     };
   
     useEffect(() => {
         getSalesCondition()
     },[]);
    return (
        <>
        <div>
        <Box
            sx={{
                minWidth: 650,
                gap: "10px",
                display: "flex",
                flexDirection: "column",
                maxHeight: 400,
            }}
            aria-label="simple table"
        >
            <Box sx={{ display: "flex", flexDirection: "row", flex: 1 }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        " > div:first-of-type p":{
                            paddingTop:0,
                        }
                    }}
                >
                    <ShipToAddress
                        onSelectChange={createChangeValueHandler(
                            "deliveryAddress"
                        )}
                    />
                    <InvoicesAddress />
                    <OfferOrderReference
                        isOffer={false}
                        value={formFields.ponReference}
                        onChange={createChangeHandler("ponReference")}
                        offerReferenceValid={false}
                        onChangeOfferReferenceValid={() => {}}
                    />
                    <DeliveryDate
                        onChangeDeliveryDateValid={(value: boolean) => {}}
                        onChange={createChangeValueHandler("deliveryDate")}
                    />
                    <PartialShipment
                    defaultValue={false}
                        onChange={createChangeHandler("partialShipment")}
                    />
                </Box>
                <Box sx={{ display: "flex", flex: 1, flexDirection: "column", paddingLeft: '30px', }}>
                      <SellConditionsContainer>
                          <Typography>{t("common.salesCondition")}</Typography>
                          <AppIconsDocumentChecked sx={{marginLeft:"7px"}}/>

                      </SellConditionsContainer>

                      <SalesCondition
                          open={openSalesCondition}
                          salesConditions={salesConditions}
                      />
                
                </Box>
            </Box>
            <OrderOfferNote
                value={formFields.note}
                onChange={createChangeHandler("note")}
            />
            {loading ? (
                <SkeletonList
                    mkey="MissingPartsWrongMaterialSummary"
                    cols={6}
                    rowsForCell={2}
                    hasHeader
                />
            ) : (
                <> 
                    <DialogContainer>
                        <WarrantyBasketItemsHeader />
                    </DialogContainer>
                    {items.map((item: WarrantyItemForMissing, idx: number) => (
                        <WarrantyBasketItems
                            item={item}
                            key={`${idx}_${item.code}_${item.navContext}`}  readOnly={true}                        >
                            <Box sx={{ display: "flex", gap: 5 }}>
                                <StyledInputBox sx={{ width: 150 }}>
                                    <Label2  id="reason">
                                        {t("warranty.reason")} 
                                    </Label2>
                                    <Value>{t(`warranty.${item.case}`)}</Value>
                                </StyledInputBox>
                                <StyledInputBox>
                                    <Label2 id="ExpectedQty">
                                        {t("warranty.ExpectedQty")}
                                    </Label2>
                                    <Value sx={{ width: 90 }}>
                                        {item.expectedQuantity}
                                    </Value>
                                </StyledInputBox>
                                <StyledInputBox>
                                    <Label2 id="QtyReceived">
                                        {t("warranty.QtyReceived")}
                                    </Label2>
                                    <Value sx={{ width: 90 }}>
                                        {item.quantityReceived}
                                    </Value>
                                </StyledInputBox>
                                <StyledInputBox>
                                    <Label2 id="QtyRequired">
                                        {t("warranty.QtyRequired")}
                                    </Label2>
                                    <Value sx={{ width: 90 }}>
                                        {item.required}
                                    </Value>
                                </StyledInputBox>
                                {item.case === WarrantyReason.WrongMaterial && (
                                    <StyledInputBox>
                                        <Label2 id="scrappedMaterialSite">
                                            {t("warranty.scrappedMaterialSite")}
                                        </Label2>
                                        <Value sx={{ width: 90 }}>
                                            {t(
                                                item.scrappedMaterialOnSite
                                                    ? "common.yes"
                                                    : "common.no"
                                            )}
                                        </Value>
                                    </StyledInputBox>
                                )}
                            </Box>
                        </WarrantyBasketItems>
                    ))}
                </>
            )}
        </Box>
        </div></>
    );
};

export default MissingPartsWrongMaterialSummary;
